import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { red } from '@mui/material/colors';
import { repeatEffect, settingsConfig, toFormatedDateMMDDHHmm } from 'utils/commonFunc';
import ApiService from 'services/ApiService';
import BaseMapView from 'map/BaseMapView';
import CommonMarkerLayer from 'map/layers/CommonMarkerLayer';
import { ToFeatures } from 'services/GeoJsonService';
import CommonBoundaryLayer from 'map/layers/CommonBoundaryLayer';
import CommonGuidelineLayer from 'map/layers/CommonGuidelineLayer';
import PlaceIcon from '@mui/icons-material/Place';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { rowSelectionStateInitializer } from '@mui/x-data-grid/internals';
import { useTrafficInOutTab } from 'pages/dashboard/RoadTrafficViewD'; // 새로 만든 Context를 임포트

// 1. 컨텍스트 및 프로바이더 정의
const TrafficInOutContext = createContext(null);

export function SwItsTrafficInOutProvider({ children, pageType }) {
    const [currentData, setCurrentData] = useState();
    const [overlayData, setOverlayData] = useState([]);

    const updateData = async () => {
        const response = await ApiService.get("newdashboard/integrated/GetInOutTraffic");
        if (response.status === 200) {
            const data = response.data;

            if (pageType === 'dashBoard') {
                const row = { ...data.rows };
                setCurrentData({
                    sumInTrf : data.sumInTrf,
                    sumOutTrf : data.sumOutTrf,
                    rangeInTrf : data.rangeInTrf,
                    rangeOutTrf : data.rangeOutTrf,
                    updateTime: data.updateTime,
                    rows: [row]
                });
            } else {
                setCurrentData({
                    updateTime: data.updateTime,
                    inTrf: data.sumInTrf,
                    outTrf: data.sumOutTrf
                });
            }

            const targetDef = [
                { id:'eW01', displayTitle:'의왕,군포', xyOpen: [126.984492, 37.343971], xyRoute: [126.993470, 37.323810], positioning: 'bottom-right' },
                { id:'yI01', displayTitle:'용인,성남', xyOpen: [127.073692, 37.348052], xyRoute: [127.049300, 37.306970], positioning: 'bottom-center' },
                // { id:'yI02', displayTitle:'용인,수지', xyOpen: [127.142356, 37.319988], xyRoute: [127.050580, 37.294210], positioning: 'bottom-left' },
                { id:'yI03', displayTitle:'용인,기흥', xyOpen: [127.157653, 37.255538], xyRoute: [127.057000, 37.270210], positioning: 'bottom-left' },
                { id:'yI04', displayTitle:'화성,동탄', xyOpen: [127.134064, 37.238521], xyRoute: [127.0662460, 37.247323], positioning: 'top-left' },
                { id:'hS01', displayTitle:'화성,봉담', xyOpen: [127.01612, 37.217391], xyRoute: [127.006950, 37.240580], positioning: 'top-center' },
                { id:'hS02', displayTitle:'화성,안산', xyOpen: [126.912182, 37.228543], xyRoute: [126.969730, 37.250800], positioning: 'top-right' }
            ];

            const updatedOverlayData = targetDef.map(p => {
                Object.entries(data.rows).forEach(([key, value]) => {
                    if (key.includes(p.id) && key.includes("IN")) p.inve = value;
                    if (key.includes(p.id) && key.includes("OUT")) p.outve = value;
                });
                return p;
            });
            setOverlayData(updatedOverlayData);
        }
    };
    
    useEffect(() => {
        return repeatEffect(updateData, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <TrafficInOutContext.Provider value={{ currentData, overlayData }}>
            {children}
        </TrafficInOutContext.Provider>
    );
}
export { SwItsTrafficInOutView };

export function SwItsTrafficInOutSumInfo() {
    const { activeTab } = useTrafficInOutTab(); // Context에서 상태 가져오기
    const currentData = useContext(TrafficInOutContext);
    if (!currentData.currentData || !currentData.currentData.rows || currentData.currentData.rows.length === 0) return null;
    const nestedRow = currentData.currentData.rows[0];
    const row = nestedRow[0];

    const targetDef = [
        { id: 'eW01', displayTitle: '의왕,군포' },
        { id: 'yI01', displayTitle: '용인,성남' },
        { id: 'yI02', displayTitle: '용인,수지' },
        { id: 'yI03', displayTitle: '용인,기흥' },
        { id: 'yI04', displayTitle: '화성,동탄' },
        { id: 'hS01', displayTitle: '화성,봉담' },
        { id: 'hS02', displayTitle: '화성,안산' }
    ];

    return (
        <>
            {targetDef.map(({ id, displayTitle }) => {
                const inKey = `${id}IN`;
                const outKey = `${id}OUT`;

                let displayValue = 0;
                if (activeTab === 'in') {
                    displayValue = row[inKey] || 0;
                } else if (activeTab === 'out') {
                    displayValue = row[outKey] || 0;
                }

                return (
                    <div key={id} className='gridLi flx a_center j_spc_btw'>
                        <p className='rdNm'>{displayTitle}</p>
                        <div className='flx a_flx_end j_flx_end ovlyDt'>
                            <span className='white' style={{ fontSize: 'var(--ft-36)', fontWeight: 'var(--ft-SemiBold)', margin: '0 6px -4px 20px' , color: activeTab === 'in' ? 'var(--alert-50)' : 'var(--pr-50)', }}>
                                {displayValue.toLocaleString()}
                            </span>
                            <span className='unit' style={{ fontSize: 'var(--ft-24)', marginBottom: '0' }}>대</span>
                        </div>
                    </div>
                );
            })}
        </>
    );
}


export function SwItsInOutHeaderTotalInfo({ showMonthValue = false }) {
    const { activeTab, handleTabClick } = useTrafficInOutTab();
    const contextValue = useContext(TrafficInOutContext);
    if (!contextValue || !contextValue.currentData) return null;

    const currentData = contextValue.currentData;

    const formatNumber = (num) => num.toLocaleString();
    const getSign = (diff) => diff >= 0 ? '+' : '-';
    const getChangeClass = (diff) => diff >= 0 ? 'plus' : 'minus';

    const inDiff = currentData.sumInTrf - currentData.rangeInTrf;
    const outDiff = currentData.sumOutTrf - currentData.rangeOutTrf;

    return (
        <div className='right flx flx_col a_center j_spc_btw'>
            {/* 유입 박스 */}
            <div 
                className={`inBox inOutBox flx a_center j_spc_btw ${activeTab === 'in' ? 'active' : ''}`}
                onClick={() => handleTabClick('in')}
                style={{ cursor: 'pointer' }}
            >
                <p>유입</p>
                <div className='flx flx_col a_flx_end'>
                    <div className='flx a_flx_end j_center'>
                        <span
                            className='fgr'
                            style={{ fontWeight: 'var(--ft-SemiBold)', color: 'var(--alert-50)' }}
                        >
                            {formatNumber(currentData.sumInTrf)}
                        </span>
                        <span className='unit' style={{ marginLeft: '10px', marginBottom: '10px' }}>
                            대
                        </span>
                    </div>
                    <div className='flx a_center j_center mg_t_m_10'>
                        <span className='cmpr' style={{ marginRight: '10px' }}>월 평균</span>
                        <span
                            className='cmpr'
                            style={{ fontWeight: 'var(--ft-Bold)' }}
                        >
                            {/* {getSign(inDiff)}*/}{formatNumber(Math.abs(inDiff))} 
                        </span>
                        <span className='cmpr' style={{ marginLeft: '10px' }}>
                            대
                        </span>
                    </div>
                </div>
            </div>

            {/* 유출 박스 */}
            <div 
                className={`outBox inOutBox flx a_center j_spc_btw ${activeTab === 'out' ? 'active' : ''}`}
                onClick={() => handleTabClick('out')}
                style={{ cursor: 'pointer' }}
            >
                <p>유출</p>
                <div className='flx flx_col a_flx_end'>
                    <div className='flx a_flx_end j_center'>
                        <span
                            className='fgr'
                            style={{ fontWeight: 'var(--ft-SemiBold)', color: 'var(--pr-50)' }}
                        >
                            {formatNumber(currentData.sumOutTrf)}
                        </span>
                        <span className='unit' style={{ marginLeft: '10px', marginBottom: '10px' }}>
                            대
                        </span>
                    </div>
                    <div className='flx a_center j_center mg_t_m_10'>
                        <span className='cmpr' style={{ marginRight: '10px' }}>월 평균</span>
                        <span
                            className='cmpr'
                            style={{ fontWeight: 'var(--ft-Bold)' }}
                        >
                            {/* {getSign(outDiff)}*/}{formatNumber(Math.abs(outDiff))} 
                        </span>
                        <span className='cmpr' style={{ marginLeft: '10px' }}>
                            대
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

const useTrafficInOut = () => useContext(TrafficInOutContext);

// 2. 하위 컴포넌트들 정의
const colors = ['var(--pr-50)', 'var(--alert-50)','#272D4B','#382A47'];

const InOutLine = ({ isIn, value }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
        <div style={{ 
            padding: '8px 0', 
            color:'var(--white)',
            width: '80px',
        }}>
            <p style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', margin: 0 ,}}>
                {isIn ? '유입' : '유출'}
            </p>
        </div>
        <p style={{ fontSize: '30px', fontWeight: '500', padding: '8px', margin: 0 ,color: isIn ? colors[1] : colors[0], }}>
            {value?.toLocaleString()} {/*<span style={{color:'var(--white)'}}>대</span>*/}
        </p>
    </div>
);

const InOutDisplayItem = ({ id, title, inValue, outValue }) => (
    <div id={id}>
        <div style={{ 
            padding: '20px', 
            transform: 'scale(1.0)',
            border:'1px solid var(--white)',
            backgroundColor:'var(--white-05)',
            //boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)', 
            borderRadius: '26px', 
            backdropFilter:'blur(14px)',
        }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' }}>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                        <p style={{ fontSize: '28px', fontWeight: '500', padding: '8px 0', margin: 0 }}>
                            {title}
                        </p>
                    </div>
                </div>
                <InOutLine isIn={false} value={outValue} />
                <InOutLine isIn={true} value={inValue} />
            </div>
        </div>
    </div>
);


const StatusInfoBox = ({ isIn, title, value, unit, bgcolor , borderColor}) => (
    <div style={{ 
        padding: '12px', 
        width: '60%',
        height:'180px',
        borderRadius: '20px',
        border: `1px solid ${borderColor}`, 
        backgroundColor : `${bgcolor}`,
        display:'flex',
        flexDirection:'column',
        alignItems:'centert',
        justifyContent:'center'
    }}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '8px' }}>
            <div style={{ 
                position: 'relative', 
                width: '100%',
            }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
                    <p style={{ fontSize: '32px', fontWeight: '500', textAlign: 'center', margin: 0 }}>
                        {title}
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: '8px', padding: '8px'}}>
                <p style={{ fontSize: '58px', fontWeight: '500', textAlign: 'center', margin: 0, }}>
                    {value}
                </p>
                <p style={{ fontSize: '32px', fontWeight: '500', textAlign: 'center', marginBottom: '14px' }}>
                    {unit}
                </p>
            </div>
        </div>
    </div>
);
//유입유출 바  새로 만든거 ** 재디자인
const InOutStyledBoxWithBar = ({ title, inValue = 0, outValue = 0 }) => {
    const max = Math.max(inValue, outValue, 1); 
    const inBarHeight = `${(inValue / max) * 100}%`;
    const outBarHeight = `${(outValue / max) * 100}%`;

    return (
        <div style={{
            width: '300px',
            backgroundColor: '#161b2d',
            borderRadius: '20px',
            padding: '14px',
            color: 'white',
            border: '1px solid var(--gs-90)',
            boxShadow: 'inset 0 0 10px rgba(0,0,0,0.2)'
        }}>
            {/* 제목 */}
            <div style={{
                border: '0.5px solid var(--white-50)',
                background:'var(--white-05)',
                borderRadius: '12px',
                padding: '10px',
                textAlign: 'center',
                marginBottom: '10px',
            }}>
                <PlaceIcon style={{ verticalAlign: 'middle', marginRight: '6px' }} />
                <span style={{ fontSize: '20px', fontWeight: '600' }}>{title}</span>
            </div>

            {/* 유입/유출 값 */}
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                <div style={{
                    flex: 1,
                    textAlign: 'center',
                    border: '1px solid var(--alert-50)',
                    borderRadius: '12px',
                    padding: '8px',
                    gap:'8px',
                }}>
                    <div style={{ fontSize: '18px' }}>유입</div>
                    <div style={{ fontSize: '28px', fontWeight: '700', color: 'var(--white)' }}>{inValue.toLocaleString()}</div>
                </div>
                {/* 막대 그래프 */}
                <div style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'flex-end',
                height: '80px',
                marginTop: '10px',
                gap: '8px'
                }}>
                <div style={{
                    width: '10px',
                    backgroundColor: '#f45c96',
                    height: inBarHeight,
                    borderRadius: '10px 10px 0 0',
                }} />
                <div style={{
                    width: '10px',
                    backgroundColor: '#5d68f2',
                    height: outBarHeight,
                    borderRadius: '10px 10px 0 0',
                }} />
            </div>
                <div style={{
                    flex: 1,
                    textAlign: 'center',
                    border: '1px solid var(--pr-50)',
                    borderRadius: '12px',
                    padding: '10px',
                    gap:'10px',
                }}>
                    <div style={{ fontSize: '18px' }}>유출</div>
                    <div style={{ fontSize: '28px', fontWeight: '700', color: 'var(--white)' }}>{outValue.toLocaleString()}</div>
                </div>
            </div>
        </div>
    );
};

const SwItsTrafficInOutView = ({ pageType }) => {
    const mapRef = useRef();
    const { currentData, overlayData } = useTrafficInOut();

    useEffect(() => {
        if (mapRef.current && overlayData.length > 0) {
            const map = mapRef.current.GetOlMap();
            map.addLayer(new CommonBoundaryLayer(map));
            
            const layerGuideline = new CommonGuidelineLayer(map);
            map.addLayer(layerGuideline);

            const layerMarker = new CommonMarkerLayer(map);
            map.addLayer(layerMarker);

            const overlay = mapRef.current.GetOverlayContainer();

            overlayData.forEach(item => {
                overlay.AddOrUpdate(
                    item.id,
                    item.xyOpen,
                    item.positioning,
                    () => <InOutStyledBoxWithBar id={item.id} title={item.displayTitle} inValue={item.inve} outValue={item.outve} />
                );
            });
            
            layerGuideline.update(overlayData.map(p => [p.xyOpen, p.xyRoute]));
            layerMarker.update(ToFeatures(overlayData.map(p => ({x:p.xyRoute[0], y:p.xyRoute[1]}))));
        }
    }, [overlayData]);

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>

            {/* 지도 부분 */}
            <div style={{ height: '100%', width: '100%'}}>
                <BaseMapView
                    ref={mapRef}
                    initViewData={{ zoom: 11.8, center: [126.98, 37.29] }}
                />
            </div>

            {/* 상태 정보 박스 */}
            {pageType === 'dashBoard' && currentData && (
                <div style={{ position: 'absolute', width: '100%', height: '100%', left:'50%', transform:'translateX(-50%)' }}>
                    <div style={{ width: '100%', display: 'flex', gap:'30px', alignItems:'center', justifyContent:'center'}}>
                        <StatusInfoBox 
                            title={'전체 유출 교통량'} 
                            unit={'대'} 
                            value={currentData.outTrf?.toLocaleString() || '0'} 
                            isIn={false} 
                            bgcolor={colors[2]} 
                            borderColor={colors[0]}
                        />
                        <StatusInfoBox 
                            title={'전체 유입 교통량'} 
                            unit={'대'} 
                            value={currentData.inTrf?.toLocaleString() || '0'} 
                            isIn={true} 
                            bgcolor={colors[3]} 
                            borderColor={colors[1]}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export function TrafficInOutViewWrapper() {
    return (
        <SwItsTrafficInOutProvider pageType="mapOnly">
        <SwItsTrafficInOutView pageType="mapOnly" />
      </SwItsTrafficInOutProvider>
    );
}